import { render } from "./PatientCreateTab.vue?vue&type=template&id=c3815648&scoped=true"
import script from "./PatientCreateTab.vue?vue&type=script&lang=js"
export * from "./PatientCreateTab.vue?vue&type=script&lang=js"

import "./PatientCreateTab.vue?vue&type=style&index=0&id=c3815648&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3815648"]])

export default __exports__